import { useState, useEffect } from 'react';
import { apiCallRadioCoverages } from '../api/calls/radioCoverage';

export const useRadioCoverages = () => {
    const [radioCoverages, setRadioCoverages] = useState([]);
    const [selectedStudyPoints, setSelectedStudyPoints] = useState([]);
    const [loadRadioCoverages, setLoadRadioCoverages] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [totalCount, setTotalCount] = useState(0);

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
      fetchRadioCoverages(newPage, rowsPerPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      const newRows = parseInt(event.target.value, 10);
      setRowsPerPage(newRows);
      setPage(0);
      fetchRadioCoverages(0, newRows);
    }

    const fetchRadioCoverages = async (pageParam = page, rowsParam = rowsPerPage) => {
      const result = await apiCallRadioCoverages.Actions.GetRadioCoverages(pageParam, rowsParam);
      if (result?.data) {
        setRadioCoverages(result.data);
        setTotalCount(result.total);
      }
    };

    const addRadioCoverage = async (radioCoverage) => {
      try {
        const dateOfCreation = new Date().toISOString();
        radioCoverage.createdAt = dateOfCreation;
        const result = await apiCallRadioCoverages.Actions.sendRadioCoverage(radioCoverage);
    
        if (result) {
          alert('Η μελέτη ραδιοκάλυψης αποθηκεύτηκε με επιτυχία!');
          setLoadRadioCoverages((prev) => !prev);
        }
        else {
          alert('Αποτυχία αποθήκευσης της μελέτης ραδιοκάλυψης.');
        }
      } catch (error) {
        console.error('API error:', error);
        alert('Συνέβη κάποιο σφάλμα κατά την αποθήκευση.');
      }
    };
    

    const loadGatewayOnMap = async (gatewayClicked) => {
        if(selectedStudyPoints.find(sp => sp.id === gatewayClicked.id)){
          setSelectedStudyPoints(selectedStudyPoints.filter(sp => sp.id !== gatewayClicked.id));
        }
        else{
          const newSelectedPoints = [...selectedStudyPoints, gatewayClicked];
          setSelectedStudyPoints(newSelectedPoints);
        }
      
    };

    const addRadioCoveragePosition = async (marker, transmission) => {
    
      const result = await apiCallRadioCoverages.Actions.AddRadioCoveragePosition(marker.radioCoverageId, marker.lat, marker.lng, transmission);

      setRadioCoverages([]);
      if (result) {
        alert("Η εισαγωγή της νέας θέσης ήταν επιτυχής!");
      } else {
        alert("Αποτυχία εισαγωγής νέας θεσης");
      }
      
    }

    useEffect(() => {
        fetchRadioCoverages();
    }, [loadRadioCoverages])


    return {
      radioCoverages,
      loadGatewayOnMap,
      selectedStudyPoints,
      addRadioCoverage,
      page,
      rowsPerPage,
      totalCount,
      handleChangePage,
      handleChangeRowsPerPage,
      addRadioCoveragePosition,
    };

}